module.exports = __webpack_public_path__ + "img/icn_radio_default.e5fb8bac.svg";